<template>
  <div class="show_all_content_wrapper">
    <main>
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.name')"
                v-model.trim="filterOptions.name"
              />

              <base-select-input
                col="6"
                :optionsList="replyStatuses"
                :placeholder="$t('PLACEHOLDERS.status')"
                v-model="filterOptions.is_active"
              />
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.providers_chats_management") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="
          paginations.items_per_page === ''
            ? 10
            : Number(paginations.items_per_page)
        "
        hide-default-footer
      >
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>

        <template v-slot:[`item.id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.user">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{ item.user.name }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.mobile`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.user">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{ item.user.mobile }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.last_message`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.last_message">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{ item.last_message.message_text }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.message_date`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.last_message">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{ item.last_message.created_at }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.message_status`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.last_message">
              {{ $t("TABLES.noData") }}
            </h6>
            <v-chip
              :color="
                item.last_message.from_type === 'admin' ? 'green' : 'orange'
              "
              text-color="white"
              small
              v-else
            >
              {{
                item.last_message.from_type === "admin"
                  ? "تم الرد"
                  : "لم يتم الرد"
              }}
            </v-chip>
          </div>
        </template>
        <template v-slot:[`item.end_at`]="{ item }">
          <div class="table_image_wrapper">
            <h6 v-if="!item.end_at">-</h6>
            <p v-else>
              {{ item.end_at }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.media`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.media">
              {{ $t("TABLES.noData") }}
            </h6>

            <button class="my-1" @click="showImageModal(item)" v-else>
              <video
                v-if="item.media.endsWith('mp4')"
                :src="item.media"
                width="80"
                height="60"
                class="rounded"
              ></video>
              <img
                v-else
                class="rounded"
                :src="item.media"
                width="60"
                height="60"
              />
            </button>
          </div>
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <div
            class="activation"
            dir="ltr"
            style="z-index: 1"
            v-if="$can('sliders activate', 'sliders')"
          >
            <v-switch
              class="mt-2"
              color="success"
              v-model="item.is_active"
              hide-details
              @change="changeActivationStatus(item)"
            ></v-switch>
          </div>

          <template v-else>
            <span class="text-success text-h5" v-if="item.is_active">
              <i class="far fa-check"></i>
            </span>
            <span class="text-danger text-h5" v-else>
              <i class="far fa-times"></i>
            </span>
          </template>
        </template>
        <!-- End:: Activation -->

        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <template>
              <div>
                <template
                  v-if="
                    $can('brands show', 'brands') ||
                    $can('brands activate', 'brands')
                  "
                >
                  <a-tooltip placement="bottom">
                    <template slot="title">
                      <span>{{ $t("BUTTONS.show") }}</span>
                    </template>
                    <button class="btn_show" @click="showItem(item)">
                      <i class="fal fa-eye"></i>
                    </button>
                  </a-tooltip>
                  <a-tooltip
                    placement="bottom"
                    v-if="$can('brands activate', 'brands')"
                  >
                    <template slot="title">
                      <span>{{ $t("PLACEHOLDERS.reply") }}</span>
                    </template>
                    <button class="btn_show" @click="showReplyDialog(item)">
                      <i class="fas fa-reply"></i>
                    </button>
                  </a-tooltip>
                </template>

                <template v-else>
                  <i
                    class="fal fa-lock-alt fs-5 blue-grey--text text--darken-1"
                  ></i>
                </template>
              </div>
            </template>
          </div>
        </template>

        <template v-slot:top>
          <image-modal
            v-if="dialogImage"
            :type="selectedItemType"
            :modalIsOpen="dialogImage"
            :modalImage="selectedItemImage"
            @toggleModal="dialogImage = !dialogImage"
          />

          <description-modal
            v-if="dialogDescription"
            :modalIsOpen="dialogDescription"
            :modalDesc="selectedDescriptionTextToShow"
            @toggleModal="dialogDescription = !dialogDescription"
          />
          <v-dialog v-model="replyDialog">
            <v-card>
              <div class="w-100">
                <div class="filter_form_wrapper">
                  <form>
                    <div class="row">
                      <base-input
                        type="textarea"
                        rows="4"
                        v-model.trim="reply"
                        :placeholder="$t('PLACEHOLDERS.replyMessage')"
                      />
                    </div>
                    <div class="text-center mt-5">
                      <v-btn
                        :disabled="replyLoading || reply.length == 0"
                        :loading="replyLoading"
                        class="modal_confirm_btn mx-1 bg-success text-white"
                        @click="replyHandler(reply)"
                        >{{ $t("PLACEHOLDERS.reply") }}</v-btn
                      >
                      <v-btn
                        class="modal_confirm_btn mx-1 bg-danger text-white"
                        @click="closeReplyDialog()"
                        >{{ $t("BUTTONS.cancel") }}</v-btn
                      >
                    </div>
                  </form>
                </div>
              </div>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </main>

    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "AllAds",

  
  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    replyStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.replied"),
          value: "replied",
        },
        {
          id: 2,
          name: this.$t("STATUS.notReplied"),
          value: "not_replied",
        },
      ];
    },
  },

  data() {
    return {
      replyDialog: false,
      reply: "",
      itemToReply: null,
      myHeaderCheck: false,
      changeStatus: false,
      selected: [],
      isWaitingRequest: false,

      filterFormIsActive: false,
      filterOptions: {
        name: null,
        phone: null,
        is_active: null,
      },

      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Clients.serialNumber"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.providerName"),
          value: "name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.phone"),
          value: "mobile",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.last_message"),
          value: "last_message",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.message_status"),
          value: "message_status",
          align: "center",
          sortable: false,
          width: "150",
        },
        {
          text: this.$t("PLACEHOLDERS.message_date"),
          value: "message_date",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.Clients.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],

      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogDelete: false,
      itemToDelete: null,
      selectedItemType: null,
      replyLoading: false,

      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
    };
  },

  watch: {
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.myHeaderCheck = false;
      this.selected = [];
      this.setTableRows();
    },
    "paginations.items_per_page"(newVal, oldVal) {
      this.paginations.current_page = 1;
      this.debouncedFetch();
    },
    selected(data) {
      if (data.length == 0) {
        this.myHeaderCheck = false;
      } else {
        this.myHeaderCheck = true;
      }
    },
  },

  methods: {
    async replyHandler() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("to_type", "provider");
      REQUEST_DATA.append("message", this.reply);
      REQUEST_DATA.append("to_id", this.itemToReply.user.id);
      this.replyLoading = true;
      try {
        await this.$axios({
          method: "POST",
          url: `provider-chats/${this.itemToReply.id}/send-message`,
          data: REQUEST_DATA,
        });
        this.reply = "";
        this.$message.success(this.$t("MESSAGES.replied_successfully"));
        this.itemToReply = [];
        this.replyDialog = false;
        this.setTableRows();
      } catch (error) {
        this.$message.error(error.response.data.message);
      } finally {
        this.replyLoading = false;
      }
    },
    showReplyDialog(item) {
      console.log(item);
      this.itemToReply = item;
      this.replyDialog = true;
    },
    closeReplyDialog() {
      this.itemToReply = null;
      this.replyDialog = false;
    },
    handleHeaderClick() {
      if (this.myHeaderCheck) {
        this.selected = this.tableRows;
      } else {
        this.selected = [];
      }
    },
    async confirmDeleteSelected() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("_method", "DELETE");
      this.selected.map((item, index) => {
        REQUEST_DATA.append(`ids[${index}]`, `${item.id}`);
      });
      try {
        await this.$axios({
          method: "POST",
          url: `sliders/remove-many`,
          data: REQUEST_DATA,
        });
        this.dialogDelete = false;
        this.selected = [];
        this.myHeaderCheck = false;
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.delete_selected_successfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },

    debouncedFetch: debounce(function () {
      this.setTableRows();
    }, 500),
    // Start:: Handel Filter
    openDeleteDialogForSelected() {
      this.itemToDelete = null;
      this.dialogDelete = true;
    },

    async confirmChangeSelectedStatus() {},
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/provider-chats/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.name = null;
      this.filterOptions.phone = null;
      this.filterOptions.is_active = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/provider-chats/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },

    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    async setTableRows() {
      this.loading = true;

      try {
        let res = await this.$axios({
          method: "GET",
          url: "provider-chats",
          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.name,
            phone: this.filterOptions.phone,
            status: this.filterOptions.is_active?.value,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data;
        this.paginations.last_page = res.data.meta.last_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    showDescriptionModal(description) {
      this.dialogDescription = true;
      this.selectedDescriptionTextToShow = description;
    },

    async changeActivationStatus(item) {
      try {
        await this.$axios({
          method: "POST",
          url: `sliders/activate/${item.id}`,
        });
        this.$message.success(this.$t("MESSAGES.changeActivation"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },

    editItem(item) {
      this.$router.push({ path: `/chats/edit/${item.id}` });
    },

    showItem(item) {
      console.log(item);
      this.$router.push({
        path: `/provider-chats/show/${item.user.id}`,
      });
    },

    showImageModal(item) {
      this.dialogImage = true;
      this.selectedItemImage = item.media;
      const videoExtensions = [
        "mp4",
        "mov",
        "avi",
        "wmv",
        "flv",
        "mkv",
        "webm",
        "m4v",
      ];
      const fileExtension = item.media.split(".").pop().toLowerCase();
      this.selectedItemType = videoExtensions.includes(fileExtension)
        ? "video"
        : "image";
    },

    // ===== Start:: Delete
    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },

    async confirmDeleteItem() {
      try {
        await this.$axios({
          method: "DELETE",
          url: `sliders/${this.itemToDelete.id}`,
        });
        this.dialogDelete = false;
        this.tableRows = this.tableRows.filter((item) => {
          return item.id != this.itemToDelete.id;
        });
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },
    // ===== End:: Delete

    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();

    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.disable_parent {
  cursor: no-drop !important;
}

.disable_child {
  opacity: 0.5;
  pointer-events: none !important;
}
</style>
